module.exports = __webpack_public_path__ + "static/media/SostenibilitàSistemica_ASSETS-Fish_20.4aefd1f3.png";